export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage === '' && error.members[0] === 'afficheurId') {
      messages.push({
        message: 'modificationOrdreTravailAffichage.messages.errors.afficheurObligatoire',
      });
    }
    if (errorMessage.indexOf('LEAST_ONE_PRODUCT') === 0) {
      messages.push({
        message: 'modificationOrdreTravailAffichage.messages.errors.auMoinsUneFace',
      });
    }
    if (errorMessage.indexOf('STATE_SHOULD_NOT_BE_CLOSED') === 0) {
      const code = errorMessage.split('|')[0].split('@')[1];
      messages.push({
        message: 'listeOrdreTravailAffichage.messages.error.otNotDelete',
        parametres: {
          code: code,
        },
      });
    }
    if (errorMessage.indexOf('OTAFFICHAGE_QUANTITEPRODUITNONVALIDE') === 0) {
      const code = errorMessage.split(' ')[1];
      messages.push({
        message: 'listeOrdreTravailAffichage.messages.error.otQuantiteNonValide',
        parametres: {
          code: code,
        },
      });
    }
  });
}

export function validationExportOt(response, messages) {
  response.error.validationErrors.forEach((error) => {
    const errorMessage = error.message;
    if (errorMessage.indexOf('ID_CANNOT_BE_EMPTY')) {
      messages.push({
        message: 'detailOrdreTravailAffichage.messages.errors.otIdObligatoire',
      });
    }
  });
}
